import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_64a9u4sm: FaireBrandEntity = {
  token: "b_64a9u4sm",
  type: "brand",
  name: "The Rustic House",
  avatarUrl:
    "https://cdn.faire.com/fastly/ad19f3e3b8c0186f39eef350c00b0054229778bfb31b047458af0c525734b491.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1618098eb684589ad503d11af3168ce32afd05a6a844712cc82a9e041155903b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ad19f3e3b8c0186f39eef350c00b0054229778bfb31b047458af0c525734b491.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1618098eb684589ad503d11af3168ce32afd05a6a844712cc82a9e041155903b.png",
  location: "Chattanooga , TN, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 491,
  isTopShop: true,
  isInsider: true,
  description:
    'My best friend and I have been inseparable since 7th grade. After working at a mom-and-pop shop that pivoted from furniture to candles in 2008, I started testing formulations at 18. With $500, a used wax machine, and recycled jars cleaned in a turkey fryer, we spent two years perfecting our blends in the garage before officially launching The Rustic House in 2013.\n\nWeekends meant hand-packaging for Sunday markets while offering $2 off for returned containers to keep recycling and gather feedback. That early support, plus my best friend’s partnership and a dedicated team, helped us grow from garage weekends to nationwide wholesale by 2015.\n\nToday, our clean-burning candles, travel tins, wax melts, and reed diffusers (made with no dyes or additives and beautiful nature-inspired scents) speak for themselves. They create welcoming, calming, and connecting moments, like background music for your nose.\n\nOur mantra, "Follow Your Scentses", is proof that with passion for what you love and hard work, dreams really do come true! \n\nOur products exist to bring more joy, love, and light into everyday life, and we invite our customers to "Follow Your Scents" and create more positive moments for themselves and others.\n\nLove + Light~\nEmily-Founder\n',
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:56.926Z",
    importedBy: "entity-db-cli",
  },
};
